var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-image",class:{ _cover: _vm.isCover }},[(!_vm.aspectRatio && !_vm.isCover)?_c('img',{ref:"image",staticClass:"ui-image__image",class:{ _visible: _vm.isLoaded },attrs:{"src":_vm.image,"loading":"lazy"}}):_c('common-lazy-background',{attrs:{"aspect-ratio":_vm.isCover ? null : _vm.aspectRatio,"image":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }